import type { BariPreSecretarialAssistantMedScreeningReportDataV1 } from '@common/validation/customControls/bariPre/bariPreSecretarialAssistantMedScreeningReport/v1/bariPreSecretarialAssistantMedScreeningReportDataV1';
import type { BariPreSecretarialAssistantMedScreeningReportDataV2 } from '@common/validation/customControls/bariPre/bariPreSecretarialAssistantMedScreeningReport/v2/bariPreSecretarialAssistantMedScreeningReportDataV2';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { BariPreSecretarialAssistentMedScreeningReportEdit } from './BariPreSecretarialAssistantMedScreeningReportEdit';
import { BariPreSecretarialAssistentMedScreeningReportRead } from './BariPreSecretarialAssistantMedScreeningReportRead';
import { initialDataV1 } from './v1/bariPreSecretarialAssistantMedScreeningReportDataV1';
import { initialDataV2 } from './v2/bariPreSecretarialAssistantMedScreeningReportDataV2';

const code = CustomControlCode.BariPreSecretarialAssistentMedScreeningReport;

CustomControlRegistry.instance.register<BariPreSecretarialAssistantMedScreeningReportDataV1>({
    EditElement: BariPreSecretarialAssistentMedScreeningReportEdit,
    ReadElement: BariPreSecretarialAssistentMedScreeningReportRead,
    canCopyReadSections: true,
    code,
    initialData: initialDataV1,
    version: 1,
});

CustomControlRegistry.instance.register<BariPreSecretarialAssistantMedScreeningReportDataV2>({
    EditElement: BariPreSecretarialAssistentMedScreeningReportEdit,
    ReadElement: BariPreSecretarialAssistentMedScreeningReportRead,
    canCopyReadSections: true,
    code,
    initialData: initialDataV2,
    version: 2,
});
